/**
 * Shared blog post SEO values for client-side head updates and build-time prerender.
 * CommonJS so Node (prerender script) loads without ESM/CJS ambiguity — CRA/webpack still `import` this file.
 */

const SITE_ORIGIN = 'https://www.orivonai.com';
const DEFAULT_OG_IMAGE = 'https://orivonai.com/images/og-image.jpg';

function toAbsoluteBlogAssetUrl(pathOrUrl) {
  const s = String(pathOrUrl || '').trim();
  if (!s) return '';
  if (/^https?:\/\//i.test(s)) return s;
  return `${SITE_ORIGIN}${s.startsWith('/') ? s : `/${s}`}`;
}

/**
 * @param {object} post — BLOG_POSTS entry
 * @param {object} author — BLOG_AUTHORS[post.authorId]
 * @returns {Array<[string, string, string]>} [attrName, key, value]
 */
function buildBlogPostMetaPairs(post, author) {
  const description = String(post.metaDescription || '').trim().slice(0, 160);
  const title = String(post.documentTitle || '').trim();
  const canonicalUrl = `${SITE_ORIGIN}/blog/${post.slug}`;
  const imageUrl =
    toAbsoluteBlogAssetUrl(post.ogImageSrc || post.pullImageSrc) || DEFAULT_OG_IMAGE;
  const imageAlt = String(post.ogImageAlt || post.pullImageAlt || title).trim();
  const authorName = String(author?.name || 'Vanessa Mosbacker').trim();

  const pairs = [
    ['property', 'og:type', 'article'],
    ['property', 'og:url', canonicalUrl],
    ['property', 'og:title', title],
    ['property', 'og:description', description],
    ['property', 'og:image', imageUrl],
    ['property', 'og:image:alt', imageAlt],
    ['property', 'og:image:width', '1200'],
    ['property', 'og:image:height', '630'],
    ['name', 'twitter:card', 'summary_large_image'],
    ['name', 'twitter:title', title],
    ['name', 'twitter:description', description],
    ['name', 'twitter:image', imageUrl],
  ];

  if (post.ogPublishedAt) {
    pairs.push(['property', 'article:published_time', String(post.ogPublishedAt).trim()]);
  }
  pairs.push(['property', 'article:author', authorName]);

  return pairs.filter(([, , v]) => Boolean(v));
}

module.exports = {
  SITE_ORIGIN,
  DEFAULT_OG_IMAGE,
  toAbsoluteBlogAssetUrl,
  buildBlogPostMetaPairs,
};
